import { render, staticRenderFns } from "./ConwayGrid.vue?vue&type=template&id=8840d0a2&scoped=true"
import script from "./ConwayGrid.vue?vue&type=script&lang=ts"
export * from "./ConwayGrid.vue?vue&type=script&lang=ts"
import style0 from "./ConwayGrid.vue?vue&type=style&index=0&id=8840d0a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8840d0a2",
  null
  
)

export default component.exports